<div class="content-box principal-content">
    <div class="table-menu">
        <div class="container">
            <div class="row">
            </div>
        </div>
    </div>

    <div class="container">
        <p class="principal-title">Sin Acceso</p>       
        <div class="row">
            <div class="col-md-4">
                <p class="page-title"><strong>No tiene los permisos para acceder.</strong></p>
            </div>
        </div>
    </div>
</div>


